export const isJobCompleted = (job) => job.jobVariations.every((jv) => jv.status === 'COMPLETED');
export const isJobFailed = (job) => job.jobVariations.some((jv) => ['FAILED', 'UPLOADING_FAILED'].includes(jv.status));
export const upperFirst = (str) => str.charAt(0).toLocaleUpperCase() + str.slice(1).toLocaleLowerCase();
export const renditionToUrl = (rendition) => (rendition?.status === 'RENDERED' ? rendition.storagePath : undefined);
